import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function DiferencialHibrido() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="py-20 bg-white text-blue-950 overflow-hidden pt-[0px] pb-[0px]" data-id="element-200">
      <div className="max-w-5xl mx-auto px-4" data-id="element-201">
        {/* BLOQUE 1: La Promesa de Orden */}

        {/* BLOQUE 2: El Diferencial */}
        <div className="space-y-12" data-id="element-202">
          <div className="text-center" data-id="element-203">
            <h2 className="text-2xl md:text-4xl font-black uppercase tracking-tight leading-tight max-w-4xl mx-auto text-blue-950" data-id="element-204">
              ¿QUÉ HACE QUE ESTE SISTEMA SEA EL DIFERENCIAL PARA TU{' '}
              <span className="text-teal-600" data-id="element-205">
                PROCESO PERSONAL O PROFESIONAL
              </span>
              ?
            </h2>
          </div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} className="grid gap-4" data-id="element-206">
            {['Explorar tu sistema familiar con total claridad y dominio de la técnica.', 'Eliminar bloqueos, dudas e inseguridades al mirar tus dinámicas ancestrales.', 'Contar con guiones, preguntas clave y protocolos listos para cada paso del camino.', 'Profundizar en nudos sistémicos complejos sin sentirte abrumado o estancado.', 'Vivir una experiencia de transformación profunda, profesional y estructurada.'].map((benefit, idx) => <motion.div key={idx} variants={itemVariants} className="flex items-center gap-4 bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-blue-100 group hover:scale-[1.01] transition-transform hover:shadow-md" data-id="element-207">
                <div className="shrink-0 text-teal-500" data-id="element-208">
                  <CheckCircle2 size={24} data-id="element-209" />
                </div>
                <p className="text-blue-950 font-bold md:text-lg leading-tight" data-id="element-210">
                  {benefit}
                </p>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}